/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useMemo, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { Formik, Form } from 'formik';
import { Col, Row } from 'react-bootstrap';

import SendToApproveAllLines from '../SendToApproveAllLines/SendToApproveAllLines';
import useWorkReport from '../../../../hooks/useWorkReport';
import NoWorkReports from '../../NoWorkReports';
import {
  AttachedFilesPermissions,
  PositionLinePermissions
} from '../../../MonthlyServiceRequest/RequestDetailTypes';
import { certificationServiceStatus } from '../../../../constants/constants';
import { statusEnum, workReportLineStatus } from '../../../../utils/dataStatus';
import LineRowContainerGeneric from '../../LineRowContainerGeneric/LineRowContainerGeneric';
import { useFilterContext } from '../../../../context/FilterDetailSDSContext';
import SupportingDocumentMultipleButton from '../../SupportingDocumentMultipleButton/SupportingDocumentMultipleButton';
import { checkRol } from '../../../../security';
import { notificador, proveedorNotificador } from '../../../../security/constantsRols';

import HeaderTable from './LineTableContainer/HeaderTable';

import './DailyView.scss';

const DailyView = (props) => {
  const {
    changeInLines,
    setChangeInLines,
    newFetch,
    setNewFetch,
    positionLinesPermissions,
    typeOfUbication,
    idParteDiario,
    disabledEditStateCancelOrFinish,
    forceWindow,
    filesPermissions,
    isOyM,
    isNotificationWindowOpen,
    notificaPP,
    asignationType,
    details,
    endingDate,
    initialDate
  } = props;

  const [linesToApprove, setLinesToApprove] = useState([]);
  const [colors, setColors] = useState([]);

  const { filter } = useFilterContext();

  const { fetchLinesByDay, linesByDay, setLinesByDay, workReportId, startDate, calendarDate } =
    useWorkReport();

  const form = useRef();

  const handleColors = (lines, idSelectedLineFromCert = null) => {
    const colorsAux = lines.map((line) => {
      const lineIsRejectedAndAproved =
        line?.estadoRevision?.estadoCertEnum === certificationServiceStatus.reject &&
        line?.estadoEnum === workReportLineStatus.aprobar;

      const lineIsWhitAlert = line?.idParteDiario === idSelectedLineFromCert;

      const color = lineIsRejectedAndAproved ? '#999999' : '#000';
      const backgroundColor = lineIsWhitAlert ? '#FF66661A' : '';
      const border = lineIsWhitAlert ? '1px solid #FF6666' : 'none';

      return {
        color,
        backgroundColor,
        border,
        disabledInput: lineIsRejectedAndAproved
      };
    });

    setColors(colorsAux);
  };

  useEffect(() => {
    if (forceWindow !== null) fetchLinesByDay(undefined, undefined, filter);
  }, [workReportId, filter, forceWindow]);

  useEffect(() => {
    form?.current?.setValues({
      line: linesByDay
    });
    handleColors(linesByDay, idParteDiario);
    setLinesToApprove(linesByDay);
  }, [linesByDay]);

  useEffect(() => {
    setLinesToApprove(form?.current?.values?.line);
  }, [changeInLines]);

  const initialValues = {};

  const isProviderOrNotifier = useMemo(
    () => checkRol(proveedorNotificador) || checkRol(notificador),
    []
  );

  const isActiveService = useMemo(
    () => details?.estadoEnum === statusEnum.enEjecucion,
    [details?.estadoEnum]
  );

  return (
    <>
      {linesByDay.length ? (
        <>
          <ul className="list_container">
            <HeaderTable />
            <Row>
              <Col className="label_row_position" sm={3} style={{ paddingRight: '30px' }}>
                Posición
              </Col>
              <Col className="label_row_position" sm={3} style={{ paddingLeft: '30px' }}>
                Línea
              </Col>
              <Col className="label_row_position" sm={1} style={{ paddingLeft: '40px' }}>
                UM
              </Col>
              <Col className="label_row_position" sm={5}>
                <Row className="count-daily-view">
                  <Col sm={6} style={{ paddingLeft: '15px', paddingRight: 0 }}>
                    Cantidad
                  </Col>
                  <Col className="label_row_position justify-content-start p-0" sm={6}>
                    {isProviderOrNotifier && (
                      <SupportingDocumentMultipleButton
                        data={{
                          ...linesByDay?.[0],
                          ubicacionStr: details?.ubicacionStr
                        }}
                        disabled={!isActiveService}
                        maxDate={endingDate}
                        minDate={initialDate}
                        selectedDate={calendarDate}
                        setNewFetch={setNewFetch}
                      />
                    )}
                  </Col>
                </Row>
              </Col>
            </Row>
            <Formik initialValues={initialValues} innerRef={form}>
              {({ values }) => (
                <Form>
                  {values?.line?.map((line, index) => (
                    <li
                      className="general_row_container"
                      key={`${line.idParteDiario}-${line.lineName}`}
                      style={colors[index]}
                    >
                      <LineRowContainerGeneric
                        asignationType={asignationType}
                        changeInLines={changeInLines}
                        disabledEditStateCancelOrFinish={disabledEditStateCancelOrFinish}
                        disabledInput={colors[index].disabledInput}
                        enableNotification={line.habilitaNotificacion}
                        filesPermissions={filesPermissions}
                        forceWindow={forceWindow}
                        indexLine={index}
                        isNotificationWindowOpen={isNotificationWindowOpen}
                        isOyM={isOyM}
                        line={line}
                        maxDate={endingDate}
                        minDate={initialDate}
                        newFetch={newFetch}
                        notificaPP={notificaPP}
                        positionLinesPermissions={positionLinesPermissions}
                        selectedDate={calendarDate}
                        setChangeInLines={setChangeInLines}
                        setNewFetch={setNewFetch}
                        setWorkReportLines={setLinesByDay}
                        startDate={startDate}
                        typeOfUbication={typeOfUbication}
                      />
                    </li>
                  ))}
                </Form>
              )}
            </Formik>
          </ul>
          <SendToApproveAllLines
            disabledByRol={!positionLinesPermissions.sendToApprove}
            newFetch={newFetch}
            selectedDate={calendarDate}
            setNewFetch={setNewFetch}
            workReportLines={linesToApprove || []}
          />
        </>
      ) : (
        <NoWorkReports title="No disponés de líneas para la fecha seleccionada" />
      )}
    </>
  );
};

DailyView.propTypes = {
  details: PropTypes.shape({
    ubicacionStr: PropTypes.string,
    estadoEnum: PropTypes.number
  }),
  changeInLines: PropTypes.bool.isRequired,
  setChangeInLines: PropTypes.func,
  setNewFetch: PropTypes.func.isRequired,
  newFetch: PropTypes.bool.isRequired,
  typeOfUbication: PropTypes.shape({
    id: PropTypes.number.isRequired,
    nombre: PropTypes.string.isRequired
  }).isRequired,
  positionLinesPermissions: PositionLinePermissions.isRequired,
  idParteDiario: PropTypes.number,
  disabledEditStateCancelOrFinish: PropTypes.bool.isRequired,
  forceWindow: PropTypes.bool,
  filesPermissions: AttachedFilesPermissions,
  isOyM: PropTypes.bool,
  isNotificationWindowOpen: PropTypes.bool,
  notificaPP: PropTypes.bool.isRequired,
  asignationType: PropTypes.number.isRequired,
  initialDate: PropTypes.string,
  endingDate: PropTypes.string
};

DailyView.defaultProps = {
  details: {},
  setChangeInLines: () => {
    /* empty */
  },
  idParteDiario: null,
  isOyM: false,
  forceWindow: null,
  isNotificationWindowOpen: false,
  filesPermissions: {
    visualize: false,
    write: false
  },
  initialDate: null,
  endingDate: null
};

export default DailyView;
